<template>
  <div class="h-100" style="min-height: 1px">
    <div v-bar class="bar-out">
      <div>
        <server-table
          ref="table"
          table-class="table-sm"
          :api-request="apiRequest"
          :columns="table.columns"
          :busy.sync="table.loading"
          :sort-by.sync="table.sortBy"
          :sort-desc="true"
          :searchable="false"
          striped
          @refreshed="onLoaded"
        >
          <template #cell(event)="data">
            <template v-if="data.value === 'created'">
              <b-icon class="mr-1 text-success" icon="plus" scale="1.5x" />
              Pridané
            </template>
            <template v-else-if="data.value === 'updated'">
              <b-icon class="mr-1 text-warning" icon="pencil" />
              Upravené
            </template>
          </template>
          <template #cell(old_values)="data">
            <div v-if="data.item.customer && Object.keys(data.value).length">
              <b-badge variant="primary" class="align-top fs-base">
                <b-icon class="mr-1" icon="person-fill" />
                Zákazník
              </b-badge>
            </div>
            <template v-if="Object.keys(data.value).length">
              <div
                v-if="data.item.energetics && data.item.energetics.powerNumber"
              >
                <b-badge class="bg-power align-top fs-base">
                  <icon class="icon-fw mr-1" name="plug" scale="0.75" />
                  {{ data.item.energetics.powerNumber }}
                </b-badge>
              </div>
              <div
                v-if="data.item.energetics && data.item.energetics.gasNumber"
              >
                <b-badge class="bg-gas align-top fs-base">
                  <icon class="icon-fw mr-1" name="fire" scale="0.75" />
                  {{ data.item.energetics.gasNumber }}
                </b-badge>
              </div>
              <div
                v-if="data.item.energetics && data.item.energetics.waterNumber"
              >
                <b-badge class="bg-water align-top fs-base">
                  <icon class="icon-fw mr-1" name="tint" scale="0.75" />
                  {{ data.item.energetics.waterNumber }}
                </b-badge>
              </div>
              <div
                v-if="data.item.energetics && data.item.energetics.heatNumber"
              >
                <b-badge class="bg-heat align-top fs-base">
                  <icon class="icon-fw mr-1" name="sun" scale="0.75" />
                  {{ data.item.energetics.heatNumber }}
                </b-badge>
              </div>
              <ul class="pl-4 mb-0">
                <li
                  v-for="(field, key) in data.value"
                  :key="key"
                  class="text-muted"
                >
                  <strong>
                    <template
                      v-if="
                        data.item.auditable_type === 'App\\Models\\Customer'
                      "
                      >{{ $t('customer.' + key) }}
                    </template>
                    <template
                      v-else-if="
                        data.item.auditable_type === 'App\\Models\\Energetics'
                      "
                      >{{ $t('energetics.' + key) }}
                    </template>
                    :
                  </strong>
                  <template v-if="key.includes('Pass')"> ***** </template>
                  <template v-else-if="key.includes('Date')">
                    {{ field | formatDate }}
                  </template>
                  <template v-else>
                    {{ field }}
                  </template>
                </li>
              </ul>
            </template>
          </template>
          <template #cell(new_values)="data">
            <div v-if="data.item.customer">
              <b-badge variant="primary" class="align-top fs-base">
                <b-icon class="mr-1" icon="person-fill" />
                Zákazník
              </b-badge>
            </div>
            <div
              v-if="data.item.energetics && data.item.energetics.powerNumber"
            >
              <b-badge class="bg-power align-top fs-base">
                <icon class="icon-fw mr-1" name="plug" scale="0.75" />
                {{ data.item.energetics.powerNumber }}
              </b-badge>
            </div>
            <div v-if="data.item.energetics && data.item.energetics.gasNumber">
              <b-badge class="bg-gas align-top fs-base">
                <icon class="icon-fw mr-1" name="fire" scale="0.75" />
                {{ data.item.energetics.gasNumber }}
              </b-badge>
            </div>
            <div
              v-if="data.item.energetics && data.item.energetics.waterNumber"
            >
              <b-badge class="bg-water align-top fs-base">
                <icon class="icon-fw mr-1" name="tint" scale="0.75" />
                {{ data.item.energetics.waterNumber }}
              </b-badge>
            </div>
            <div v-if="data.item.energetics && data.item.energetics.heatNumber">
              <b-badge class="bg-heat align-top fs-base">
                <icon class="icon-fw mr-1" name="sun" scale="0.75" />
                {{ data.item.energetics.heatNumber }}
              </b-badge>
            </div>
            <ul class="pl-4 mb-0">
              <li v-for="(field, key) in data.value" :key="key">
                <strong>
                  <template
                    v-if="data.item.auditable_type === 'App\\Models\\Customer'"
                    >{{ $t('customer.' + key) }}
                  </template>
                  <template
                    v-else-if="
                      data.item.auditable_type === 'App\\Models\\Energetics'
                    "
                    >{{ $t('energetics.' + key) }}
                  </template>
                  :
                </strong>
                <template v-if="key.includes('Pass')"> ***** </template>
                <template v-else-if="key.includes('Date')">
                  {{ field | formatDate }}
                </template>
                <template v-else>
                  {{ field }}
                </template>
              </li>
            </ul>
          </template>
          <template #cell(created_by)="data">
            <template v-if="data.item.user">
              <template v-if="$root.user.isAdmin">
                {{ data.item.user.firstname }} {{ data.item.user.lastname }}
              </template>
              <template v-else> ESM </template>
            </template>
            <template v-else> - </template>
          </template>
        </server-table>
      </div>
    </div>
  </div>
</template>
<script>
import ServerTable from '@/components/ServerTable'

export default {
  components: {
    ServerTable,
  },
  data() {
    return {
      table: {
        loading: false,
        columns: [
          {
            key: 'event',
            label: 'Udalosť',
            class: 'text-nowrap',
            sortable: true,
          },
          {
            key: 'old_values',
            label: 'Pôvodné hodnoty',
          },
          {
            key: 'new_values',
            label: 'Nové hodnoty',
          },
          {
            key: 'created_at',
            label: 'Dátum a čas',
            formatter: (value) =>
              value ? this.$options.filters.formatDateTime(value) : '-',
            sortable: true,
          },
          {
            key: 'created_by',
            label: 'Užívateľ',
            sortable: true,
          },
        ],
        sortBy: 'created_at',
      },
    }
  },
  methods: {
    apiRequest(params) {
      return this.$api.get(`customers/get_audits/${this.$route.params.id}`, {
        params: params,
      })
    },
    onLoaded() {
      //this.count = this.$refs.table.count
    },
  },
}
</script>
